module.exports = __webpack_public_path__ + "img/jquery.minicolors.44ae4fdb.png";